import {
  AppstoreOutlined,
  BankOutlined,
  BellFilled,
  BranchesOutlined,
  ContainerOutlined,
  DesktopOutlined,
  FormOutlined,
  GiftOutlined,
  GitlabOutlined,
  LeftOutlined,
  MailOutlined,
  PieChartOutlined,
  RightOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  TagOutlined,
  UsergroupAddOutlined,
  FileOutlined,
} from '@ant-design/icons';
import {
  Button,
  ConfigProvider,
  Dropdown,
  Layout,
  Menu,
  MenuProps,
  Spin,
} from 'antd';
import MenuItem from 'antd/lib/menu/MenuItem';
import { avatar, logo_pnj, menuLogo } from 'assets/images';
import { useUser } from 'contexts/User';
import React, { ReactNode, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import sidebarMenu from 'constants/menu';
import MainHeader from './MainHeader';
import { Branch, Settings, gitPullRequest } from 'assets/svg';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  isError?: boolean;
  error?: string;
}

const MainLayout = (props: IProps): JSX.Element => {
  const { children, isLoading = false, isError, error } = props;
  const { user, signOut } = useUser();

  const history = useHistory();
  const location = useLocation<{ key: string }>();

  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [user]);

  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  type MenuItem = Required<MenuProps>['items'][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
  ): MenuItem {
    return {
      key: key,
      icon: icon,
      children: children,
      label: label,
      type: type,
    } as MenuItem;
  }

  // const items: MenuItem[] = user?.role.includes('nguoi_dat_hang')
  //   ? [
  //       getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
  //         getItem('Đăng ký sản phẩm', '/product-register'),
  //       ]),
  //       // getItem('Sản phẩm', '/product', <GiftOutlined />),
  //     ]
  //   : user?.role.includes('cua_hang_truong')
  //   ? [
  //       getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
  //         getItem('Đăng ký sản phẩm', '/product-register'),
  //       ]),
  //       // getItem('Sản phẩm', '/product', <GiftOutlined />),
  //       getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
  //         getItem('Vốn tồn cửa hàng', '/plants-allocate'),
  //       ]),
  //       getItem('Phê duyệt', 'approves', <FileOutlined />, [
  //         getItem('Phê duyệt đơn hàng', '/list-approve'),
  //         getItem('Phê duyệt phân bổ', '/approve-order-list'),
  //       ]),
  //     ]
  //   : user?.plantCode == 1000
  //   ? [
  //       getItem('Danh mục hàng hóa', '/category', <AppstoreOutlined />),
  //       getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
  //         getItem('Phát hành giỏ hàng', '/cart-list'),
  //         getItem('Đăng ký sản phẩm', '/product-register'),
  //       ]),
  //       user?.role.includes('admin') &&
  //         getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
  //           getItem('Danh sách vốn tồn ', '/branchs-capital'),
  //         ]),
  //       getItem('Phê duyệt', 'approves', <FileOutlined />, [
  //         getItem('Danh mục hàng hóa', '/approve-category-list'),
  //         getItem('Phê duyệt đơn hàng', '/list-approve'),
  //       ]),

  //       getItem('Sản phẩm', '/product', <GiftOutlined />),
  //       user?.role.includes('admin') &&
  //         getItem('Người dùng & Phân quyền', 'user', <UsergroupAddOutlined />, [
  //           getItem('Phân quyền', '/role-based-auth'),
  //           getItem('Cập nhật Role - Job Title', '/mapping-job-title'),
  //         ]),

  //       getItem('Thiết lập', 'settings', <SettingOutlined />, [
  //         getItem('Phê duyệt', '/department-approval'),
  //         getItem('Bộ phận phát triển', '/brand'),
  //         getItem('Tủ hàng', '/branch-cabinet'),
  //         // getItem('DMKN', '/recommended-list'),
  //       ]),
  //     ]
  //   : [
  //       // getItem('Danh mục hàng hoá', '/category', <AppstoreOutlined />),
  //       getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
  //         getItem('Đăng ký mẫu (Chi nhánh)', '/preorder'),
  //         getItem('Đăng ký sản phẩm', '/product-register'),
  //       ]),
  //       getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
  //         getItem('Vốn tồn chi nhánh', '/branchs-capital-detail'),
  //       ]),
  //       getItem('Phê duyệt', 'approves', <FileOutlined />, [
  //         // getItem('Danh mục hàng hoá', '/approve-category-list'),
  //         getItem('Phê duyệt đơn hàng', '/list-approve'),
  //         getItem('Phê duyệt phân bổ', '/approve-order-list'),
  //       ]),
  //       // getItem('Sản phẩm', '/product', <GiftOutlined />),
  //     ];

  const items: MenuItem[] = user?.role.includes('nguoi_dat_hang')
    ? [
        getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
          getItem('Đăng ký sản phẩm', '/product-register'),
        ]),
        // getItem('Sản phẩm', '/product', <GiftOutlined />),
      ]
    : user?.role.includes('cua_hang_truong')
    ? [
        getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
          getItem('Đăng ký sản phẩm', '/product-register'),
        ]),
        // getItem('Sản phẩm', '/product', <GiftOutlined />),
        getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
          getItem('Vốn tồn cửa hàng', '/plants-allocate'),
        ]),
        getItem('Phê duyệt', 'approves', <FileOutlined />, [
          getItem('Phê duyệt đơn hàng', '/list-approve'),
          getItem('Phê duyệt phân bổ', '/approve-order-list'),
        ]),
      ]
    : user?.role.includes('asm') ||
      user?.role.includes('rsm') ||
      user?.role.includes('gdcn') ||
      user?.role.includes('cukv') ||
      user?.role.includes('quan_ly') ||
      (user?.role.includes('admin') && user?.plantCode != 1000)
    ? [
        // getItem('Danh mục hàng hoá', '/category', <AppstoreOutlined />),
        getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
          getItem('Đăng ký mẫu (Chi nhánh)', '/preorder'),
          getItem('Đăng ký sản phẩm', '/product-register'),
        ]),
        getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
          getItem('Vốn tồn chi nhánh', '/branchs-capital-detail'),
        ]),
        getItem('Phê duyệt', 'approves', <FileOutlined />, [
          // getItem('Danh mục hàng hoá', '/approve-category-list'),
          getItem('Phê duyệt đơn hàng', '/list-approve'),
          getItem('Phê duyệt phân bổ', '/approve-order-list'),
        ]),
        // getItem('Sản phẩm', '/product', <GiftOutlined />),
      ]
    : user?.plantCode == 1000
    ? [
        getItem('Danh mục hàng hóa', '/category', <AppstoreOutlined />),
        getItem('Giỏ hàng', 'cart', <ShoppingCartOutlined />, [
          getItem('Phát hành giỏ hàng', '/cart-list'),
          getItem('Đăng ký sản phẩm', '/product-register'),
        ]),
        user?.role.includes('admin') &&
          getItem('Thông tin đơn vị', 'info', <BranchesOutlined />, [
            getItem('Danh sách vốn tồn ', '/branchs-capital'),
          ]),
        getItem('Phê duyệt', 'approves', <FileOutlined />, [
          getItem('Danh mục hàng hóa', '/approve-category-list'),
          getItem('Phê duyệt đơn hàng', '/list-approve'),
        ]),

        getItem('Sản phẩm', '/product', <GiftOutlined />),
        user?.role.includes('admin') &&
          getItem('Người dùng & Phân quyền', 'user', <UsergroupAddOutlined />, [
            getItem('Phân quyền', '/role-based-auth'),
            getItem('Cập nhật Role - Job Title', '/mapping-job-title'),
          ]),

        getItem('Thiết lập', 'settings', <SettingOutlined />, [
          getItem('Phê duyệt', '/department-approval'),
          getItem('Bộ phận phát triển', '/brand'),
          getItem('Tủ hàng', '/branch-cabinet'),
          // getItem('DMKN', '/recommended-list'),
        ]),
      ]
    : [];

  return (
    <Spin className="!max-h-screen" size="large" spinning={isLoading}>
      {/* {isError && error && openNotificationWithIcon('error', error)} */}
      <Layout className="min-h-screen">
        <Sider
          width={262}
          trigger={null}
          collapsible
          collapsed={collapsed}
          className="py-5"
        >
          <div className="flex items-center justify-between px-5">
            {!collapsed && (
              <img
                src={menuLogo}
                width={60}
                height={60}
                alt="logo"
                className="cursor-pointer"
                onClick={() => history.push('/')}
              />
            )}
            <Button
              onClick={toggleCollapsed}
              className="bottom-0 drop-shadow-sidebar-button rounded-full"
            >
              {React.createElement(collapsed ? RightOutlined : LeftOutlined)}
            </Button>
          </div>
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  darkItemColor: 'white',
                  darkItemSelectedBg: 'white',
                  darkItemSelectedColor: '#C9A46D',
                  darkSubMenuItemBg: '#003056',
                  darkItemHoverBg: '#001529',
                  popupBg: 'red',
                },
              },
            }}
          >
            <Menu
              theme="dark"
              style={{
                minWidth: 0,
                flex: 'auto',
                background: 'transparent',
              }}
              defaultOpenKeys={location.state?.key ? [location.state.key] : []}
              selectedKeys={[location.pathname]}
              mode="inline"
              inlineCollapsed={collapsed}
              items={items}
              onSelect={(e) => {
                history.push(e.keyPath[0], {
                  key: e.keyPath.length > 1 ? e.keyPath[1] : undefined,
                });
              }}
            />
          </ConfigProvider>
        </Sider>
        <Layout>
          <MainHeader></MainHeader>
          <Content
            id="main"
            className="px-9 py-5 m-0"
            style={{ padding: '0px 24px' }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Spin>
  );
};

// const renderSideBar = (functions?: string[]) => {
//   const menu = sidebarMenu.filter((submenu) =>
//     submenu.active
//       ? submenu.active.filter((item) => functions?.includes(item)).length
//       : submenu
//   );
//   return (
//     <>
//       {menu.map((item) => (
//         <>
//           {item.submenu ? (
//             <SubMenu key={item.key} icon={<item.icon />} title={item.title}>
//               {item.submenu
//                 .filter((i) => functions?.includes(i.active))
//                 .map((m) => (
//                   <MenuItem key={m.key}>
//                     {m.title}
//                     <Link to={m.key} />
//                   </MenuItem>
//                 ))}
//             </SubMenu>
//           ) : (
//             <MenuItem key={item.key} icon={<item.icon />}>
//               <span style={{ marginInlineStart: 10 }}>{item.title}</span>
//               <Link to={item.key} />
//             </MenuItem>
//           )}
//         </>
//       ))}
//     </>
//   );
// };

export default MainLayout;
